/**
 * It returns milliseconds difference between first and second date
 * @param {Date} firstDate - The first date.
 * @param {Date} secondDate - The second date.
 * @returns The difference between the two dates in milliseconds.
 */
export const getTimeDifferenceBetweenDates = (firstDate: Date, secondDate: Date): number => {
  const millisecondsInSecond = 1000;

  return (
    Math.round((firstDate.getTime() - secondDate.getTime()) / millisecondsInSecond) *
    millisecondsInSecond
  );
};
